import { StorageManager } from "@aws-amplify/ui-react-storage";
import React from 'react'
// import s3putupload from "../aws_utils/s3putupload";
// import getuser from "../aws_utils/getAuthuser";
// import { getUser } from "../apigateway/mongocalls";
import { useUserStore } from "store";
 

export default function CustomUpload(props) {
  const { userdb } = useUserStore();
  const projectname = props.projectname
  const [subscribed, setsubscribed] = React.useState(true)
  React.useEffect(() => {
    const currentUser = async () => {
    // const user = await getuser()
    // const sub = user.attributes.sub

    try {
    //   const realmuser = await getUser(sub)
    // // console.log("Realm User", realmuser)
    //   const allagents = realmuser.all_agents
    // console.log(realmuser)
      setsubscribed(userdb.all_agents)
    } catch (error) {
      console.log(error)
    }
    

    }

    currentUser()
  }, [userdb.all_agents])
  

  const ProcessFile = async ({ file, key }) => {
    // console.log("Processing File", file)

    // const user = await getuser()
    // const keyname = `${user.username}${key}`
    // setfiledata(file)

    return {
      file,
      key: `${projectname} ${key}`,
    };
  };

  
  // const PutTextract = async ({key}) => {
  //   const user = await getuser()
  //   const keyname = `${user.username}${key}`
  //   const puts3 = await s3putupload(keyname, filedata)
  //   console.log("Put Response", puts3)

  // }



  return (
    <StorageManager
      acceptedFileTypes={[
      // '.csv',
      // '.docx',
      // '.json',
      ".pdf",
      // or MIME types:
      `${subscribed ? 'image/png' : ""}`,
      `${subscribed ? 'image/jpg' : ""}`,
      `${subscribed ? 'image/jpeg' : ""}`,
      // `${subscribed ? 'image/heic' : ""}`,
      // 'video/*',
    ]}
      onUploadSuccess={() => {
        alert("Successfully uploaded document, go to 'My Documents'!")
      }}
      accessLevel="private"
      processFile={ProcessFile}
      // onUploadSuccess={PutTextract}
      maxFileCount={5}
      // isResumable
    />
  )
}


